import React from "react";
import KiotOrdersComponent from "../KiotOrders/KiotOrdersComponent";

const KiotOrders = props => {
    return <KiotOrdersComponent tab={3} status={'3'} screenTitle={'Danh sách đơn hàng đã giao'}/>
};

export default KiotOrders;
